
class WelcomeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Welcome';

        super(entityName);
    }

    welcome = () => {
        window.location = "#/RouteMonitor";
    }
}

App.Routers.Welcome = WelcomeRouter;
